export enum ToolBoxCellName {
    Export = '导出',
    FullScreen = '全屏',
    Sma = '均线',
    Annotation = '批注',
};
